// extracted by mini-css-extract-plugin
export default {"container":"tTm58KpeKxCc_0w0SaSg"};